import React from "react";
import Home from "../../components/Home/Home";

const Generate = () => {
  return (
    <div className="mb-16">
      <Home></Home>
    </div>
  );
};

export default Generate;
